import { axiosInstance } from '../axios';

const API_URL = '/api/locations';

class LocationService {
  async getLocationHierarchy() {
    return axiosInstance.get(API_URL + '/hierarchy');
  }
}

export default new LocationService();
